<template>
  <div class="bg-light-gray rounded-bottom p-2">
    <div class="bg-white rounded pt-4 px-5">
      <p class="font-16 mb-3">
        <i class="font-20 fas fa-headset mr-2 text-orange"></i>
        Relacionar con DE Ticket
      </p>
      <div class="row">
        <validation-observer
          ref="specialReport"
          v-slot="{}"
          tag="form"
          class="w-100"
        >
          <div class="col-12 d-flex justify-content-between w-100">
            <validation-provider
              v-slot="{ errors }"
              rules="required"
              class="w-100"
            >
              <autocomplete-and-create
                ref="autocompleteTicketRef"
                class="w-100"
                :suggestions="ticketsOptions"
                v-model="currentTicket"
              />
              <error
                v-if="errors[0]"
                variant="no-border"
                message="Este campo es requerido"
              />
            </validation-provider>
            <action-button
              @click="addTicket"
              i="fas fa-file-plus"
              variant="success"
              id="btn-search"
              text="Añadir"
              class="ml-3"
            />
          </div>
        </validation-observer>
        <div class="col-12 pl-2" :class="!listOfTikects.length && 'mb-5'">
          <custom-chips-group
            v-if="listOfTikects.length"
            class="text-left chips-group_extended"
            no-background
            no-wrap
            object-sub-title="name"
            @itemMarkedForDeletion="onItemDeletedHandler"
            :selected-items="listOfTikects"
            title=""
            :can-remove="canRemoveTicket"
          />
        </div>
      </div>
    </div>
    <div class="row mt-4 mb-3 px-5">
      <div class="col-12 d-flex justify-content-end">
        <action-button
          @click="$emit('close')"
          i="fas fa-times-circle"
          variant="outline-danger"
          id="btn-search"
          text="Cerrar"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton'
import { CustomChipsGroup, AutocompleteAndCreate } from '@/components/common'
import SpecialService from '@/services/api/special.api'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Error from 'custom-error'
export default {
  name: 'Related',
  components: {
    ActionButton,
    CustomChipsGroup,
    AutocompleteAndCreate,
    ValidationObserver,
    ValidationProvider,
    Error,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tickets: [],
      currentTicket: null,
    }
  },
  computed: {
    ticketsOptions() {
      return this.tickets || []
    },
    listOfTikects() {
      return this.value.tickets || []
    },
    canRemoveTicket() {
      return this.userHasPermissions(
        'menu.report.specialInform.remove.relationtodeticket'
      )
    },
  },
  mounted() {
    this.getTickets()
  },
  methods: {
    async getTickets() {
      const { data } = await SpecialService.getTickets().catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })
      this.tickets = data.data
        ?.map((x) => ({ name: x.text, ...x }))
        .filter((el) => !this.listOfTikects.find((rm) => rm.ticketId === el.id))
    },
    async addTicket() {
      const isValid = await this.$refs.specialReport.validate()

      if (!isValid || !this.currentTicket?.id) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      const confirm = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea asociar el ticket ${this.currentTicket?.caseNumber}?`,
        'Sí',
        'No'
      )

      if (!confirm) return

      const { data } = await SpecialService.addTickets({
        QueryBuilderId: this.value.id,
        TicketId: this.currentTicket?.id,
        TicketNumber: this.currentTicket?.caseNumber,
        TicketDate: this.currentTicket?.createdDate,
        TicketUserId: this.currentTicket?.userId,
        TicketUserName: this.currentTicket?.userName,
      }).catch((err) => {
        this.$refs.autocompleteTicketRef?.onClearHandler()
        this.currentTicket = null
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })

      if (data) {
        this.$refs.autocompleteTicketRef?.onClearHandler()
        this.currentTicket = null
        this.$emit('load-tickets')
        setTimeout(() => {
          this.getTickets()
        }, 500)
      }
    },
    async onItemDeletedHandler(item) {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover el ticket ${item?.name}?`,
        'Sí',
        'No'
      )

      if (!confirm) return

      const { data } = await SpecialService.removeTickets({
        QueryBuilderId: this.value.id,
        TicketId: item?.ticketId,
        TicketNumber: item?.name,
        TicketDate: item?.ticketDate,
        TicketUserId: item?.ticketUserId,
        TicketUserName: item?.userName,
      }).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })
      if (data) {
        this.currentTicket = null
        this.$emit('load-tickets')
        setTimeout(() => {
          this.getTickets()
        }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#btn-search {
  height: fit-content;
}
</style>
